import React, { Component } from 'react'
import { View, Platform } from 'react-native'
import Slider from '../../Atoms/VerticalSlider'
import { lighten } from 'polished'
import styled from 'styled-components/native'

import Donut from '../../Atoms/Donut'
import Icon from '../../Atoms/Icon'
import { Text } from '../../Atoms/Typography'
import Touchable from '../../Atoms/Touchable'
import TranslatedText from '../../Atoms/TranslatedText'
import theme from '../../../styles/theme'

import { percentage } from '../../../lib/formatters'

const isIOS = Platform.OS === 'ios'
const SLIDER_HEIGHT = isIOS ? 300 : 240
const DONUT_HEIGHT = isIOS ? 140 : 130

const Container = styled(Touchable)``

const Content = styled(View)`
  align-items: center;
`

const VerticalSliderColumn = styled(View)`
  align-items: center;
  justify-content: flex-start;
`

const ZeroMark = styled(View)`
  height: 2px;
  width: 20px;
  position: absolute;
  top: ${isIOS ? 250 : 160}px;
  background-color: ${theme.colours.grey};
`

const Slider1Container = styled(View)`
  position: absolute;
  transform: rotate(${Platform.select({ web: '90deg', default: '-90deg' })});
  width: ${SLIDER_HEIGHT}px;
  top: ${isIOS ? 230 : 140}px;
`

const DonutAndIconContainer = styled(View)`
  margin-top: ${theme.gutterUnit * 2}px;
  align-items: center;

`

const IconContainer = styled(View)`
  position: absolute;
  width: ${DONUT_HEIGHT + 2 * theme.gutterUnit}px;
  height: ${isIOS ? DONUT_HEIGHT + theme.gutterUnit : DONUT_HEIGHT - theme.gutterUnit}px;
  background-color: ${props => props.selected ? theme.colours.active : theme.colours.white};
  top: ${DONUT_HEIGHT / 2}px;
  align-items: center;
  justify-content: center;
  border-color: ${theme.colours.grey};
  border-top-width: 1px;
`

const EffectiveDecisionContainer = styled(View)`
  position: absolute;
  width: ${DONUT_HEIGHT}px;
  height: ${DONUT_HEIGHT / 2}px;
  background-color: ${props => props.selected ? theme.colours.active : theme.colours.white};
  align-items: center;
  justify-content: flex-end;
`

const colours = [
  lighten(0.1, theme.colours.blue),
  lighten(0.1, theme.colours.orange),
  lighten(0.1, theme.colours.magenta),
  lighten(0.1, theme.colours.aqua),
  lighten(0.1, theme.colours.green)
]

const formatPercentage = (val, dp, hidePercentage) => {
  if (val === 0) {
    return '-'
  }
  return percentage(val, dp, hidePercentage)
}

const iconByType = {
  IT_OPERATIONS: 'calculator',
  FRONT_LINE: 'headphones',
  RISK_COMPLIANCE: 'research',
  HR_TRAINING: 'work',
  SALARY_GROWTH: 'saveMoney'
}

export default class OpexCostColumn extends Component {
  render () {
    const { numberOfColumns, data, index, enableChanges, decision, onChangeValue, effectiveDecision, type, selected, onPress } = this.props
    const showBorder = type === 'SALARY_GROWTH'
    const colour = colours[index % colours.length]
    const icon = iconByType[type]
    return (
      <Container
        selected={selected}
        onPress={onPress}
        touchableStyle={{
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          height: '100%',
          width: `${100 / numberOfColumns}%`,
          padding: theme.gutterUnit,
          borderColor: theme.colours.grey,
          borderLeftWidth: showBorder ? 1 : 0,
          borderRightWidth: showBorder ? 1 : 0,
          backgroundColor: selected ? theme.colours.active : theme.colours.white
        }}
      >

        {/* <Container selected={selected} numberOfColumns={numberOfColumns} showBorder={data.type === 'SALARY_GROWTH'}> */}
        <Content>
          <TranslatedText proximaBold size={isIOS ? 'l' : 'm'} uppercase value={`operatingCosts.businessfunctions.${type}.name`} default={data.name} />
          {/* <Text medium size='l'>{formatPercentage(decision, 0)}</Text> */}

          <DonutAndIconContainer>
            <EffectiveDecisionContainer selected={selected}>
              <Text medium size={isIOS ? 'xxl' : 'xl'}>{formatPercentage(effectiveDecision, 0)}</Text>
              <TranslatedText medium size={isIOS ? 'xs' : 'xs'} value={`operatingCosts.businessfunctions.${type}.sliderUnit`} default={data.type === 'SALARY_GROWTH' ? 'Staff Pay Rises' : 'Output'} />
            </EffectiveDecisionContainer>
            <Donut
              colour={colour}
              backgroundColour={theme.colours.grey}
              min={data.minValue * 2 * 100}
              max={data.maxValue * 2 * 100}
              value={decision}
              height={DONUT_HEIGHT}
              startAngle={-Math.PI / 2}
              endAngle={Math.PI / 2}
              stroke={isIOS ? 15 : 12}
            />

            <IconContainer selected={selected}>
              <Icon size='huger' colour={colour} name={icon} />
            </IconContainer>
          </DonutAndIconContainer>
          <VerticalSliderColumn>
            <ZeroMark />
            <Slider1Container>
              <Slider
                key={`${data.type}Slider`}
                value={decision}
                onValueChange={value => {
                  if (!selected) {
                    onPress()
                  }
                  onChangeValue({ [data.type]: value })
                }}
                minimumValue={data.minValue * 100}
                maximumValue={data.maxValue * 100}
                minimumTrackTintColor={enableChanges ? theme.colours.primary : theme.colours.grey}
                maximumTrackTintColor={theme.colours.grey}
                thumbTintColor={enableChanges ? theme.colours.primary : theme.colours.grey}
                thumbTouchSize={{ width: 80, height: 80 }}
                step={100}
                orientation='vertical'
                inverted
                disabled={!enableChanges}
              />
            </Slider1Container>
          </VerticalSliderColumn>
        </Content>
      </Container>
    )
  }
}
